import { createContext, useContext } from 'react';
import get from 'transmute/get';
import memoizeOne from 'react-utils/memoizeOne';
import { getCanAccessPipeline } from '../utils/getCanAccessPipeline';
import { jsx as _jsx } from "react/jsx-runtime";
export const generateSortedPipelines = memoizeOne(pipelines => [...pipelines].sort((pipeline1, pipeline2) => {
  const canAccessPipeline1 = getCanAccessPipeline(pipeline1);
  const canAccessPipeline2 = getCanAccessPipeline(pipeline2);
  if (!canAccessPipeline1 && canAccessPipeline2) {
    return 1;
  } else if (!canAccessPipeline2 && canAccessPipeline1) {
    return -1;
  }
  return get('displayOrder', pipeline1) - get('displayOrder', pipeline2);
}));
const PipelinesContext = /*#__PURE__*/createContext(null);
export const ProvidePipelines = ({
  rawValue,
  children
}) => /*#__PURE__*/_jsx(PipelinesContext.Provider, {
  value: generateSortedPipelines(rawValue),
  children: children
});
export const usePipelines = () => useContext(PipelinesContext);